import { EnvConfig } from '../types';
import { config as configStg } from './stg';

const prEnv = process.env.REACT_APP_IS_PR_ENV === 'true';
const baseDomain = !prEnv ? 'app.d.alloyads.ai' : window.location.host.replace(/^pr-\d+-/i, '');

export const config: EnvConfig = {
  ...configStg,
  env: 'dev',
  api: {
    ...configStg.api,
    baseUrl: `https://${baseDomain}/api`,
  },
};
